import { useTranslation } from "react-i18next"

import Bone from "../../../../Components/Skeleton/Bone"
import { CHANNEL_COUNT } from "../../utils/vocabulary"

import styles from "./matchRateGrid.module.less"

// The heat map in its own table and classes, so the columns, the 132px row heads and the 44px
// cells sit exactly where they will: a program mark per column, a channel name per row, and the
// legend, which does not depend on the data, as it is.
const MatchRateGridSkeleton = ({ programCount }) => {
  const { t } = useTranslation()
  const cols = Array.from({ length: programCount }, (_, i) => i)

  return (
    <>
      <div className={styles.wrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.rowHead} />
              {cols.map((c) => (
                <th key={c}>
                  <span className={styles.head}>
                    <Bone width={20} height={20} />
                    <Bone width={88} height={12} />
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: CHANNEL_COUNT }, (_, r) => (
              <tr key={r}>
                <td className={styles.rowHead}>
                  <Bone width={88} height={14} />
                </td>
                {cols.map((c) => (
                  <td key={c}>
                    <Bone block height={44} radius={8} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.legend}>
        <span>{t("Lower match rate")}</span>
        <span className={styles.scale} />
        <span>{t("Higher match rate")}</span>
      </div>
    </>
  )
}

export default MatchRateGridSkeleton
